document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('vhs-overlay');
  const overlayText = document.getElementById('vhs-overlay-text');
  const body = document.body;
  const isOfflinePage = body.classList.contains('is-offline');
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
  const isProductPage = body.classList.contains('is-product-page');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const SYSTEM_STATE = {
    STARTUP: 'startup',
    INSERT: 'insert',
    SHUTDOWN: 'shutdown',
    EASTER: 'easter'
  };

  const konamiSequence = ['arrowup', 'arrowup', 'arrowdown', 'arrowdown', 'arrowleft', 'arrowright', 'arrowleft', 'arrowright', 'b', 'a'];
  let konamiBuffer = [];
  let isTransitioning = false;

  function activateOverlay(mode, text) {
    if (!overlay || !overlayText) return;
    overlay.classList.remove(`mode-${SYSTEM_STATE.STARTUP}`, `mode-${SYSTEM_STATE.INSERT}`, `mode-${SYSTEM_STATE.SHUTDOWN}`, `mode-${SYSTEM_STATE.EASTER}`);
    overlay.classList.add('is-active', `mode-${mode}`);
    overlayText.textContent = text || '';
  }

  function hideOverlay(delay = 0) {
    if (!overlay) return;
    window.setTimeout(() => {
      overlay.classList.remove('is-active', `mode-${SYSTEM_STATE.STARTUP}`, `mode-${SYSTEM_STATE.INSERT}`, `mode-${SYSTEM_STATE.SHUTDOWN}`, `mode-${SYSTEM_STATE.EASTER}`);
      isTransitioning = false;
    }, delay);
  }

  function settleScreen() {
    if (reducedMotionQuery.matches) return;
    body.classList.remove('vhs-system-settling');
    void body.offsetWidth;
    body.classList.add('vhs-system-settling');
    window.setTimeout(() => body.classList.remove('vhs-system-settling'), 320);
  }

  function maybeGlitch() {
    if (reducedMotionQuery.matches || Math.floor(Math.random() * 12) !== 0) return;
    body.classList.add('vhs-glitching');
    window.setTimeout(() => body.classList.remove('vhs-glitching'), 260);
  }

  function productReveal() {
    if (reducedMotionQuery.matches || !isProductPage) return;
    body.classList.add('vhs-product-reveal');
    window.setTimeout(() => body.classList.remove('vhs-product-reveal'), 700);
  }

  function normalizeKey(key) {
    return String(key || '').toLowerCase();
  }

  function triggerEasterEgg() {
    if (reducedMotionQuery.matches || isTransitioning) return;
    isTransitioning = true;
    body.classList.add('vhs-secret-mode');
    activateOverlay(SYSTEM_STATE.EASTER, 'SECRET TAPE FOUND');
    window.setTimeout(() => hideOverlay(0), 1200);
    window.setTimeout(() => body.classList.remove('vhs-secret-mode'), 10000);
  }

  function handleKonami(event) {
    const key = normalizeKey(event.key);
    konamiBuffer.push(key);
    if (konamiBuffer.length > konamiSequence.length) konamiBuffer.shift();
    const matches = konamiSequence.every((value, index) => konamiBuffer[index] === value);
    if (matches) {
      konamiBuffer = [];
      triggerEasterEgg();
    }
  }

  function isInternalNavigableLink(link) {
    if (!link) return false;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;
    if (link.hasAttribute('download') || link.target === '_blank') return false;
    try {
      const url = new URL(link.href, window.location.origin);
      return url.origin === window.location.origin;
    } catch {
      return false;
    }
  }

  function shouldBypassTransition(event, link) {
    return (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link?.hasAttribute('download') ||
      link?.target === '_blank'
    );
  }

  function textForUrl(url) {
    const path = url.pathname;
    if (path === '/' || path === '/index.html') return 'BOOTING SYSTEM...';
    if (path.includes('/collections')) return 'LOADING ARCHIVE...';
    if (path.includes('/products/')) return 'CUEING FEATURE...';
    if (path.includes('/pages/about')) return 'ACCESSING FILE...';
    if (path.includes('/pages/contact')) return 'OPENING CHANNEL...';
    if (path.includes('/search')) return 'SCANNING INDEX...';
    if (path.includes('/pages/offline')) return 'POWERING OFF...';
    return 'INSERTING TAPE...';
  }

  function playInsertAndGo(url, text = 'INSERTING TAPE...', delay = 680) {
    if (reducedMotionQuery.matches) {
      window.location.href = url;
      return;
    }
    if (isTransitioning) return;
    isTransitioning = true;
    activateOverlay(SYSTEM_STATE.INSERT, text);
    window.setTimeout(() => { window.location.href = url; }, delay);
  }

  function playShutdownAndGo(url, text = 'POWERING OFF...', delay = 980) {
    if (reducedMotionQuery.matches) {
      window.location.href = url;
      return;
    }
    if (isTransitioning) return;
    isTransitioning = true;
    activateOverlay(SYSTEM_STATE.SHUTDOWN, text);
    window.setTimeout(() => { window.location.href = url; }, delay);
  }

  function playStartupAndGo(url, text = 'POWERING ON...', delay = 1080) {
    if (reducedMotionQuery.matches) {
      window.location.href = url;
      return;
    }
    if (isTransitioning) return;
    isTransitioning = true;
    body.classList.add('vhs-booting');
    activateOverlay(SYSTEM_STATE.STARTUP, text);
    sessionStorage.setItem('vhsStartupPlayed', 'true');
    window.setTimeout(() => { window.location.href = url; }, delay);
  }

  function runInitialStartup() {
    if (reducedMotionQuery.matches) {
      sessionStorage.setItem('vhsStartupPlayed', 'true');
      hideOverlay(0);
      return;
    }
    const alreadyPlayed = sessionStorage.getItem('vhsStartupPlayed');
    if (isHomePage && !alreadyPlayed) {
      isTransitioning = true;
      activateOverlay(SYSTEM_STATE.STARTUP, 'CANADA VHS');
      sessionStorage.setItem('vhsStartupPlayed', 'true');
      window.setTimeout(() => {
        hideOverlay(0);
        settleScreen();
      }, 1050);
      return;
    }
    settleScreen();
  }

  function initCartStatus() {
    const FREE_SHIPPING_THRESHOLD = 7500;
    const ELIGIBLE_PRICE_CUTOFF = 300;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD',
      minimumFractionDigits: 2
    });

    function calculateEligibleShipping(cart) {
      const eligibleSubtotal = (Array.isArray(cart?.items) ? cart.items : []).reduce((subtotal, item) => {
        const finalUnitPrice = Number(item.final_price || 0);
        const finalLinePrice = Number(item.final_line_price || 0);
        return finalUnitPrice > ELIGIBLE_PRICE_CUTOFF ? subtotal + finalLinePrice : subtotal;
      }, 0);
      const amountRemaining = Math.max(0, FREE_SHIPPING_THRESHOLD - eligibleSubtotal);

      return {
        eligibleSubtotal,
        amountRemaining,
        progress: Math.max(0, Math.min((eligibleSubtotal / FREE_SHIPPING_THRESHOLD) * 100, 100))
      };
    }

    async function updateCartStatus(cartResource) {
      const statuses = document.querySelectorAll('[data-vhs-cart-status]');
      if (!statuses.length) return;

      try {
        let cart = cartResource;
        if (!cart || !Array.isArray(cart.items)) {
          const response = await fetch('/cart.js', { credentials: 'same-origin' });
          cart = await response.json();
        }

        statuses.forEach((cartStatus) => {
          const label = cartStatus.querySelector('[data-vhs-cart-status-label]');
          const fill = cartStatus.querySelector('[data-vhs-cart-status-fill]');
          if (!label || !fill) return;

          const shipping = calculateEligibleShipping(cart);
          const unlockedText = cartStatus.dataset.unlockedText || 'Your eligible items qualify for free shipping';
          const progressTemplate = cartStatus.dataset.progressTemplate || "You're [amount] away from free shipping on eligible items";

          fill.style.width = shipping.progress + '%';
          cartStatus.hidden = Number(cart.item_count || 0) === 0;

          if (shipping.amountRemaining === 0) {
            cartStatus.dataset.unlocked = 'true';
            label.textContent = unlockedText;
            return;
          }

          cartStatus.dataset.unlocked = 'false';
          label.textContent = progressTemplate.replace('[amount]', money.format(shipping.amountRemaining / 100));
        });
      } catch (error) {
        console.error('VHS cart status failed:', error);
        document.querySelectorAll('[data-vhs-cart-status]').forEach((status) => {
          status.hidden = true;
        });
      }
    }

    updateCartStatus();
    document.addEventListener('cart:refresh', () => updateCartStatus());
    document.addEventListener('cart:updated', () => updateCartStatus());
    document.addEventListener('cart:update', (event) => updateCartStatus(event.detail?.resource));
    document.addEventListener('dialog:open', (event) => {
      if (event.target?.matches?.('cart-drawer-component, cart-drawer-component *')) {
        updateCartStatus();
      }
    });
    window.addEventListener('pageshow', () => updateCartStatus());
    document.addEventListener('click', (event) => {
      const addToCartTrigger = event.target.closest('button[type="submit"], [name="add"], .product-form__submit, .quick-add__submit');
      if (!addToCartTrigger) return;
      window.setTimeout(updateCartStatus, 700);
    });

    const cartStatusObserver = new MutationObserver((mutations) => {
      const addedStatus = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node instanceof Element &&
          (node.matches('[data-vhs-cart-status]') || node.querySelector('[data-vhs-cart-status]'))
        )
      );
      if (addedStatus) updateCartStatus();
    });
    cartStatusObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('keydown', handleKonami);

  document.addEventListener('click', (event) => {
    const clickedLink = event.target.closest('a');
    if (shouldBypassTransition(event, clickedLink)) return;

    if (isOfflinePage) {
      if (clickedLink) return;
      event.preventDefault();
      playStartupAndGo('/', 'POWERING ON...');
      return;
    }

    const powerButton = event.target.closest('[data-vhs-power]');
    if (powerButton) {
      event.preventDefault();
      playShutdownAndGo('/pages/offline', 'POWERING OFF...');
      return;
    }

    const link = clickedLink;
    if (!link || !isInternalNavigableLink(link)) return;
    const url = new URL(link.href, window.location.origin);
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    if (url.pathname === '/pages/offline') {
      event.preventDefault();
      playShutdownAndGo('/pages/offline', 'POWERING OFF...');
      return;
    }

    event.preventDefault();
    playInsertAndGo(url.href, textForUrl(url));
  });

  if (isOfflinePage) {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        playStartupAndGo('/', 'POWERING ON...');
      }
    });
  }

  window.addEventListener('pageshow', () => {
    hideOverlay(80);
    maybeGlitch();
    productReveal();
  });

  window.addEventListener('load', () => {
    runInitialStartup();
    maybeGlitch();
    productReveal();
  });

  initCartStatus();
});
